module.exports = __webpack_public_path__ + "img/暂无任何数据.a7b3f223.png";